import { render, staticRenderFns } from "./VeJwJingsaiPersonalinfoModal.vue?vue&type=template&id=38207951"
import script from "./VeJwJingsaiPersonalinfoModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiPersonalinfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports